
import { Component, Vue } from 'vue-property-decorator';
import { mapActions, mapGetters } from 'vuex';

@Component({
    computed: {
        ...mapGetters({
            isAuthenticated: 'authenticationStorage/isAuthenticated',
        }),
    },
    methods: {
        ...mapActions({
            fetchUser: 'authenticationStorage/fetchUser',
        }),
    },
})
export default class App extends Vue {
    isAuthenticated!: boolean;

    fetchUser!: () => Promise<void>;

    mounted(): void {
        if (!localStorage.getItem('lang')) {
            this.$i18n.locale = navigator.language.split('-')[0].toString();
        }

        if (this.isAuthenticated) {
            this.fetchUser().catch(() => undefined);
        }
    }
}
